<template>
  <div class="ic-form__connection">
    <h3>Połączenie</h3>
    <div class="row">
      <div class="col-md-6">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureStation"
          name="connection.departureStation"
          :aria="$t('aria_required')"
          :label="$t('label_departureStation')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcStationTypeahead 
              id="departureStation"
              v-model="data.departureStation"
              @idStation="getDepartureStationId"
              valueField="n"
              :noMeta="1" 
              :icStation="-1"
              @input="emitInput1(data,validator)"
            ></IcStationTypeahead>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-6">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="arrivalStation"
          name="connection.arrivalStation"
          :aria="$t('aria_required')"
          :label="$t('label_arrivalStation')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcStationTypeahead
              id="arrivalStation"
              v-model="data.arrivalStation"
              valueField="n"
              @idStation="getArrivalStationId"
              :noMeta="1"
              :icStation="-1"
              @input="emitInput(data,validator)"
            ></IcStationTypeahead>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureDate"
          name="connection.departureDate"
          :aria="$t('aria_required_date')"
          :label="$t('label_departureDate')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <ic-date-picker
              id="departureDate"
              v-model="data.departureDate"
              @input="emitInput(data,validator)"
              :minDate="minDate"
              :endDate="endDate"
              title=""
              aria="Strzałka w górę dół, następny poprzedni dzień."
            ></ic-date-picker>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-2 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="departureTime"
          name="connection.departureTime"
          :aria="$t('aria_required_time')"
          :label="$t('label_departureTime')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcTimePicker
              id="departureTime"
              v-model="data.departureTime"
              @input="emitInput(data,validator)"
            ></IcTimePicker>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-3">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="ticketNo"
          name="connection.ticketNo"
          :aria="$t('aria_required')"
          :label="$t('label_ticketNo')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="ticketNo" v-model="data.ticketNo" @input="emitInput(data,validator)" maxlength="20"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
      <div class="col-md-3 form-padding-left">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="trainNo"
          name="connection.trainNo"
          :aria="$t('aria_required')"
          :label="$t('label_trainNo')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="trainNo" v-model="data.trainNo" @input="emitInput(data,validator)" maxlength="50"></IcInput>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="withDelay">
        <IcFormRowWrapper
          rowElement="IcFormRow"
          id="delay"
          name="connection.delay"
          :label="$t('label_connection_delay')"
          :aria="$t('required')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcSelect
              id="delay"
              :values="delayOptions"
              v-model="data.delay"
              @input="emitInput(data,validator)"
            />
          </template>
        </IcFormRowWrapper>
      </div>
    </div>

      <div class="alert alert-warning" v-if="showAlert" aria-live="assertive" role="alert">
      <div class="krajowy" v-if="miedzynarodowy == false" v-html="$t('form_01_local')">

      </div>
      <div class="miedzynarodowy" v-if="miedzynarodowy" v-html="$t('form_01_mn')">
        

      </div>
    </div>
  </div>
</template>

<script>
import IcInput from "@/components/ic-common/form/controls/Input";
import IcInputZip from "@/components/ic-common/form/controls/InputZip";
import IcStationTypeahead from "@/components/ic-common/form/controls/StationTypeAhead";
import IcDatePicker from "@/components/ic-common/form/controls/DatePicker";
import IcTimePicker from "@/components/ic-common/form/controls/TimePicker";
import IcSelect from "@/components/ic-common/form/controls/Select";
import { Connection } from "@/components/ic/form/contact/Model/Connection";
import { emitInput } from "./mixins";
import moment from "moment";

export default {
  name: "IcFormR01Connection",
  props: {
    value: {
      type: [Object],
      default: new Connection()
    },
    withDelay: {
      type: [Boolean],
      default: false
    },
    minDate: {
      type: String,
      default: moment().format("YYYY-MM-DD")
    },
    endDate: {
      type: String,
      default: moment()
        .add(1, "years")
        .format("YYYY-MM-DD")
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      this.data = this.value;
    },
    data: {
      deep: true,
      handler(){

        this.handleKomunikat()
      }
    }
  },
  data() {
    return {
      showAlert: false,
      miedzynarodowy: false,
      delayOptions: [
        { value: "60", name: this.$t("delay_option_60") },
        { value: "120", name: this.$t("delay_option_120") }
      ],
      data: Object.assign({}, new Connection(), this.value)
    };
  },
  methods: {
    emitInput1(a,b){
      this.emitInput(a,b);
      this.handleKomunikat();
      
    },
    emitInput,
    getDepartureStationId(value) {
      this.data.departureStationId = value;
    },
    getArrivalStationId(value) {
      this.data.arrivalStationId = value;
    },
    handleKomunikat(){
        this.showAlert = false;
        //console.log(this.data.departureStationId && this.data.arrivalStationId && this.data.departureTime && this.data.departureDate,this.data.departureStationId, this.data.arrivalStationId , this.data.departureTime , this.data.departureDate);
        if(this.data.departureStationId && this.data.arrivalStationId && this.data.departureTime && this.data.departureDate){
          var date = moment(this.data.departureDate+" "+this.data.departureTime );
          var startTime = new Date();
          var duration = moment.duration(date.diff(startTime));
          var minutes = Math.round(duration.asMinutes());
          var did = this.data.departureStationId.substr(0,2);
          var aid = this.data.arrivalStationId.substr(0,2);
         // //console.log(minutes);
          if(aid == 51 && did == 51) this.miedzynarodowy = false; else this.miedzynarodowy = true;

          if(did == 21 || did == 20 || aid == 21 || aid == 20){
            if(minutes >= 375)
              this.showAlert = true;
          } else if(minutes >= 15){
              this.showAlert = true;
          }
          ////console.log(minutes,did,aid,this.miedzynarodowy)
        }


    }

  },
  components: {
    IcInput,
    IcInputZip,
    IcStationTypeahead,
    IcDatePicker,
    IcTimePicker,
    IcSelect
  }
};
</script>

<style>
</style>
